$(function () {
	var index = {
		init: function init() {
			this.yuyue()
			this.navOne()
			this.navTwo()
			this.navThree()
			this.goTop()
			this.toast()
		},
		navTwo: function navTwo() {
			// console.log($('.znqd_gift').offset().top)
			var prizeSwiper = function () {
				new Swiper('#prizeSwiper', {
					autoplay: true,
					loop: true,
					slidesPerView: 4.2,
				})
			}
			$('.shili_item').click(function () {
				$(this).addClass('active').siblings().removeClass('active')
				$('.shili_list').eq($(this).index()).show().siblings().hide()
				prizeSwiper()
			})
			prizeSwiper()
		},
		navOne: function nav() {
			$('.znqd_item').click(function () {
				$(this).addClass('cur').siblings().removeClass('cur')
				$('.znqd_list')
					.eq($(this).index())
					.addClass('active')
					.siblings()
					.removeClass('active')
			})

			var topNav = $('.znqd_nav_box').offset().top
			var top2 = $('.znqd_gift').offset().top
			$(document).scroll(function () {
				var windowTop = $(document).scrollTop()

				if (windowTop > topNav && windowTop < top2 - 20) {
					$('.znqd_nav_box').addClass('current')
					$('.znqd_hidden').show()
				} else {
					$('.znqd_nav_box').removeClass('current')
					$('.znqd_hidden').hide()
				}
			})
		},
		navThree: function () {
			var swiperTwo = function () {
				new Swiper('.book_box', {
					autoplay: {
						delay: 2000,
						disableOnInteraction: true,
					},
					loop: true,
					effect: 'coverflow',
					slidesPerView: 3,
					centeredSlides: true,
					coverflowEffect: {
						rotate: 0,
						stretch: 40,
						depth: 300,
					},
				})
			}
			$('.book_item').click(function () {
				$(this).addClass('active').siblings().removeClass('active')
				$('.book_list').eq($(this).index()).show().siblings().hide()
				swiperTwo()
			})
			swiperTwo()
		},
		goTop: function () {
			$('.piaofu_guanbi').click(function () {
				$('.piaofu').hide()
			})
			$('.piaofu_btn').click(function () {
				$('html,body').animate(
					{
						scrollTop: 0,
					},
					500
				)
			})
		},
		yuyue: function () {
			$('.znqd_form_txt ').click(function () {
				$('.znqd_form_selectBox').show()
			})
			$('.znqd_form_selectItem').click(function () {
				var _this = $(this)

				$('.znqd_form_txt ').text(_this.text())
				$('.info_city').val(_this.text())
				$('.znqd_form_selectBox').hide()
			})
			$('.znqd_form').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: 'PC校庆预约（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'PC校庆预约（360）',
					},
					{
						search: '',
						name: 'PC校庆预约',
					},
				],
				submitTarget: '.znqd_form_btn',
				cityRequired: true,
			})

			$('.form').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: ' PC校庆底部（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'PC校庆底部（360）',
					},
					{
						search: '',
						name: 'PC校庆底部',
					},
				],
				submitTarget: '#submitBtn2',
				courseRequired: true,
				cityRequired: true,
			})
			$('.select-one .option').click(function () {
				var _this = $(this)

				$('.select-one .current').text(_this.text())
				$('.couse01').val(_this.text())
			})
			$('.select-city .option').click(function () {
				var _this = $(this)

				$('.select-city .current').text(_this.text())
				$('.city03').val(_this.text())
			})
			$('.guanbi ').click(function () {
				$('.form').hide()
			})
		},
		toast: function () {
			$('.zixun').click(function () {
				$('.toumingbi_yspd').show()
				$('.leyu_yspd').show()
			})
			$('.close_ly').click(function () {
				$('.toumingbi_yspd').hide()
				$('.leyu_yspd').hide()
			})
		},
	}
	index.init()
})
